export default function isUserProbablyInTargetCountry() {
  // only run on client
  if (typeof window === 'undefined') {
    throw new Error('only run isUserProbablyInTargetCountry on the client');
  }

  const userTimezone = Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone;
  if (!userTimezone) {
    return false;
  }

  const timezoneMap = createTimezoneMap();
  return !!timezoneMap[userTimezone];
}

type TimezoneMap = {
  [timezone: string]: string[];
};

let timezoneMap: null | TimezoneMap = null;
function createTimezoneMap(): TimezoneMap {
  if (timezoneMap) {
    return timezoneMap;
  }

  const newTimezoneMap: TimezoneMap = {};
  Object.keys(TargetCountryTimezones).forEach((targetCountry) => {
    const timezones = TargetCountryTimezones[targetCountry as TargetCountries];
    timezones.forEach((timezone) => {
      if (!newTimezoneMap[timezone]) {
        newTimezoneMap[timezone] = [];
      }
      newTimezoneMap[timezone].push(targetCountry);
    });
  });

  timezoneMap = newTimezoneMap;
  return timezoneMap;
}

type TargetCountries =
  | 'USA'
  | 'Canada'
  | 'United Kingdom'
  | 'Ireland'
  | 'Australia'
  | 'New Zealand';

const TargetCountryTimezones: {
  [country in TargetCountries]: string[];
} = {
  USA: [
    'America/New_York',
    'America/Detroit',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Indiana/Indianapolis',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Vevay',
    'America/Chicago',
    'America/Indiana/Tell_City',
    'America/Indiana/Knox',
    'America/Menominee',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah',
    'America/Denver',
    'America/Boise',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Yakutat',
    'America/Nome',
    'America/Adak',
    'Pacific/Honolulu',
  ],
  Canada: [
    'America/St_Johns',
    'America/Halifax',
    'America/Glace_Bay',
    'America/Moncton',
    'America/Goose_Bay',
    'America/Blanc-Sablon',
    'America/Toronto',
    'America/Nipigon',
    'America/Thunder_Bay',
    'America/Iqaluit',
    'America/Pangnirtung',
    'America/Atikokan',
    'America/Winnipeg',
    'America/Rainy_River',
    'America/Resolute',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Swift_Current',
    'America/Edmonton',
    'America/Cambridge_Bay',
    'America/Yellowknife',
    'America/Inuvik',
    'America/Creston',
    'America/Dawson_Creek',
    'America/Fort_Nelson',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Dawson',
  ],
  'United Kingdom': ['Europe/London'],
  Ireland: ['Europe/Dublin'],
  Australia: [
    'Australia/Lord_Howe',
    'Australia/Hobart',
    'Australia/Currie',
    'Australia/Melbourne',
    'Australia/Sydney',
    'Australia/Broken_Hill',
    'Australia/Brisbane',
    'Australia/Lindeman',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
    'Australia/Eucla',
  ],
  'New Zealand': ['Pacific/Auckland', 'Pacific/Chatham'],
};
